// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  settlementId: __t.u64().primaryKey().name("settlement_id"),
  civ: __t.string(),
  tier: __t.string(),
  votes: __t.i32(),
  population: __t.i32(),
  households: __t.i32(),
  arrears: __t.i64(),
  suspended: __t.bool(),
  crossTrade: __t.i64().name("cross_trade"),
  defiant: __t.bool(),
  updatedAt: __t.timestamp().name("updated_at"),
});
